import Button from './Button';
import { I18n } from 'i18n-js/typings/I18n';
import { Config } from '../types';

const Alert = (i18n: I18n, config: Config) => {
  return (
    '<div class="ecodigo-ckm-alert">' +
    '<div>' +
    `<h3 class="ecodigo-ckm-alert__title">${i18n.t('alertTitle', { title: config.websiteTitle })}</h3>` +
    `<p class="ecodigo-ckm-alert__privacy">${i18n.t('alertBigPrivacy')}</p>` +
    '</div>' +
    '<div class="ecodigo-ckm-alert__buttons">' +
    Button({
      id: 'alert-allowAll',
      dataAction: 'allowAll',
      className: 'ecodigo-ckm-alert__buttons__button btn btn-lg btn-blue',
      content: i18n.t('alertAllowAll'),
    }) +
    Button({
      id: 'alert-customize',
      className: 'ecodigo-ckm-alert__buttons__button btn btn-lg btn-outline-blue',
      content: i18n.t('alertSettings'),
    }) +
    '</div>' +
    '</div>'
  );
};

export default Alert;
